import { createFileRoute } from "@tanstack/react-router";
import { Eigentuemer } from "../features/shell/Eigentuemer";

export const Route = createFileRoute("/eigentuemer")({
  component: Eigentuemer,
});
